import { render, staticRenderFns } from "./flight-delay-form.vue?vue&type=template&id=1c36f92f&scoped=true&"
import script from "./flight-delay-form.vue?vue&type=script&lang=js&"
export * from "./flight-delay-form.vue?vue&type=script&lang=js&"
import style0 from "./flight-delay-form.vue?vue&type=style&index=0&id=1c36f92f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36f92f",
  null
  
)

export default component.exports